import {decorate, observable, action} from "mobx"
import {defaultMapGeos} from "../../utils/utils"

export class GTMapStore {
  mapObj = {
    geo: null,
    categoryId: null,
    brandId: null,
    visitDuration: "SEVEN_DAYS",
    mapGeos: defaultMapGeos,
    showLoader: null,
    locationGroupId: null,
    tenantId: null,
    authToken: null,
    mapPadding: {left: 0},
  }
  locations = null

  setMapObj(args) {
    this.mapObj = {...this.mapObj, ...args}
  }
  setLocation(list) {
    this.locations = list
  }
}

decorate(GTMapStore, {
  mapObj: observable,
  locations: observable,
  setMapObj: action,
  setLocation: action,
})
